import React from "react";
import CreateTemplate from "@/partial/template/create-template";

const CreateTemplatePage: React.FC = () => {
  return <CreateTemplate />;
};

export default CreateTemplatePage;
